import {createSlice} from '@reduxjs/toolkit';

const initialState = {
    valueSearch: null
};

export const searchSlice = createSlice({
    name: 'search',
    initialState,
    reducers: {
        changeValueSearch: (state, action) => {
            state.valueSearch = action.payload;
        },
        resetSearch: (state) => {
            state.valueSearch = null;
        }
    }
});

export const {changeValueSearch, resetSearch} = searchSlice.actions;

export default searchSlice.reducer;
